<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between MenTopFelx">
            <div class="card-text">
              <h3>会员特殊日期</h3>
            </div>
            <div class="card-button MenTopFelx-right">
              <el-button
                class="push-button"
                icon="iconfont icon-chuangjian1"
                @click="establish"
                plain
                >创建</el-button
              >
              <el-button
                class="push-button"
                icon="iconfont icon-xiugai1"
                @click="modify"
                plain
                >修改</el-button
              >
              <el-button
                class="push-button"
                icon="iconfont icon-a-shanchu11"
                @click="deleteU"
                plain
                >删除</el-button
              >
              <el-button
                class="push-button"
                icon="iconfont icon-fanhui"
                @click="NvagetToLookMenber"
                plain
                >返回基本信息</el-button
              >
            </div>
          </div>
          <div class="NumberTable">
            <!-- table列表 -->
            <Table
              @ReadteSelectChange="ReadteSelectChange"
              @TouchTheBottom="TouchTheBottom"
              :PagesData="paging"
              ref="TableRefs"
              :tableData="list.tbody"
              :configTable="list.thead"
              :config="list"
            ></Table>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
    <div class="member-dialog">
      <el-dialog
        :title="TitlaTable"
        :visible.sync="establishg.establishgVisible"
        :show-close="false"
        width="30%"
      >
        <div class="establishg-div">
          <el-form
            label-width="120px"
            :model="establishg"
            :rules="establishgRules"
            ref="ruleFormestablishg"
          >
            <el-form-item label="客户姓名">
              <el-input
                class="input-text"
                readonly
                v-model="establishg.UserInfoName"
              ></el-input>
            </el-form-item>
            <el-form-item label="特殊日期名称" prop="dateName">
              <el-input
                class="input-text"
                v-model="establishg.dateName"
              ></el-input>
            </el-form-item>
            <el-form-item label="特殊日期" prop="date">
              <el-date-picker
                v-model="establishg.date"
                :clearable="false"
                class="input-text"
                type="date"
                placeholder="请选择日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="通知方式" prop="NotMethod">
              <el-select class="input-text" v-model="establishg.NotMethod">
                <el-option
                  v-for="item in genderOptions"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="bottom-div">
            <el-button @click="ButEstablishg()">确 定</el-button>
            <el-button @click="cancelEstablishg()">取 消</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisibleDelete" width="30%">
      <span>是否确认删除该条信息？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDelete = false">取 消</el-button>
        <el-button type="primary" @click="ButDelete">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  GetQueryCustSpecDate,
  GetSpecdateDeletee,
  GetSpecdateInsert,
  GetSpecdateUpdate,
} from "@/api/viewMemberModule";
import Table from "/src/components/NumberTable/index.vue";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      establishg: {
        //创建会员特殊日期
        establishgVisible: false,
        UserInfoName: "",
        dateName: "",
        date: "",
        NotMethod: "",
        ID: "",
        specDateText: "",
      },
      genderOptions: [
        {
          value: 0,
          label: "单次",
        },
        {
          value: 1,
          label: "每年",
        },
        {
          value: 2,
          label: "无",
        },
      ],
      dialogVisibleDelete: false,
      TitlaTable: "",
      establishgRules: {
        dateName: [
          { required: true, message: "请输入特殊日期名称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        date: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        NotMethod: [
          { required: true, message: "请选择通知方式", trigger: "change" },
        ],
      },
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages: 2,
        Loading: true,
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "",
            prop: "selection",
            width: 55,
          },
          {
            label: "特殊日期名称",
            prop: "dateName",
          },
          {
            label: "特殊日期",
            prop: "specDateText",
            width: 200,
          },
          {
            label: "通知方式",
            prop: "noticeModeText",
          },
          {
            label: "创建人",
            prop: "createUser",
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 200,
          },
          {
            label: "最后修改人",
            prop: "updateUserName",
            width: 200,
          },
          {
            label: "最后修改日期",
            prop: "updateTime",
            width: 200,
          },
        ],
        tbody: [],
      },
      ReadSelectData: {},
      DelectId: "",
    };
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
      MemberInformation: (state) => state.user.MemberInformation,
    }),
  },
  created() {
    this.RGetQueryCustSpecDate();
  },
  methods: {
    ButDelete() {
      let deleteID = this.DelectId;
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        ID: deleteID,
      });
      GetSpecdateDeletee(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.$refs.TableRefs.clearSelection();
          this.DelectId = "";
          this.ReadSelectData = {};
          this.dialogVisibleDelete = false;
          this.paging.page = 1;
          this.paging.total = 0;
          this.paging.pages = 2;
          this.list.tbody = [];
          this.paging.Loading = true;
          this.RGetQueryCustSpecDate();
        } else {
          this.$message({
            message: "删除,请重试",
            type: "warning",
          });
        }
      });
    },
    modify() {
      if (Object.keys(this.ReadSelectData).length < 1) {
        this.$message.info("请选择数据,进行修改!");
        return false;
      } else {
        this.TitlaTable = "修改会员特殊日期";
        this.establishg = {
          establishgVisible: true,
          UserInfoName:
            this.MemberInformation.lastName + this.MemberInformation.firstName,
          dateName: this.ReadSelectData.dateName,
          date: new Date(this.ReadSelectData.specDateText),
          NotMethod: this.ReadSelectData.noticeMode,
          ID: this.ReadSelectData.id,
        };
      }
    },
    deleteU() {
      if (this.DelectId.length <= 0) {
        this.$message.info("请选择数据!");
        return false;
      } else {
        this.dialogVisibleDelete = true;
      }
    },
    ReadteSelectChange(value) {
      if (value.length > 0) {
        this.DelectId = value[value.length - 1].id;
        this.ReadSelectData = value[value.length - 1];
      } else {
        this.DelectId = "";
        this.ReadSelectData = {};
      }
    },
    ZeroFilling(s) {
      return s < 10 ? "0" + s : s;
    },
    ReturnDate(date) {
      let d = new Date(date);
      return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    },
    cancelEstablishg() {
      this.establishg.establishgVisible = false;
    },
    ReturnMethod(NotMethodID) {
      let text = "";
      switch (NotMethodID) {
        case 0:
          text = "单次";
          break;
        case 1:
          text = "每年";
          break;
        case 2:
          text = "无";
          break;
      }
      return text;
    },
    ButEstablishg() {
      //确认添加
      this.$refs.ruleFormestablishg.validate((valid) => {
        if (valid) {
          let qs = require("qs");
          if (this.TitlaTable == "创建会员特殊日期") {
            let data = qs.stringify({
              cpyNo: getcpyNo,
              custID: this.MemberInformation.custID,
              dateName: this.establishg.dateName,
              specDate: this.renderTime(this.establishg.date).substring(0, 10),
              noticeMode: this.establishg.NotMethod,
            });
            GetSpecdateInsert(data).then((res) => {
              if (res.success) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.cancelEstablishg();
                this.$refs.ruleFormestablishg.resetFields();
                this.paging.page = 1;
                this.paging.page = 1;
                this.paging.total = 0;
                this.paging.pages = 2;
                this.list.tbody = [];
                this.paging.Loading = true;
                this.RGetQueryCustSpecDate();
              } else {
                this.$message({
                  message: "添加失败,请重试",
                  type: "warning",
                });
              }
            });
          } else if (this.TitlaTable == "修改会员特殊日期") {
            let data = qs.stringify({
              cpyNo: getcpyNo,
              custID: this.MemberInformation.custID,
              dateName: this.establishg.dateName,
              specDate: this.renderTime(this.establishg.date).substring(0, 10),
              noticeMode: this.establishg.NotMethod,
              ID: this.establishg.ID,
            });
            GetSpecdateUpdate(data).then((res) => {
              if (res.success) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.ReadSelectData = {};
                this.DelectId = "";
                this.cancelEstablishg();
                this.$refs.ruleFormestablishg.resetFields();
                this.paging.page = 1;
                this.paging.total = 0;
                this.paging.pages = 2;
                this.list.tbody = [];
                this.paging.Loading = true;
                this.RGetQueryCustSpecDate();
              } else {
                this.$message({
                  message: "修改失败,请重试",
                  type: "warning",
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    establish() {
      this.TitlaTable = "创建会员特殊日期";
      this.establishg = {
        establishgVisible: true,
        UserInfoName:
          this.MemberInformation.lastName + this.MemberInformation.firstName,
        dateName: "",
        date: "",
        ID: "",
        NotMethod: "",
        specDateText: "",
      };
    },
    renderTime(date) {
      if (date == null) return "";
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    RGetQueryCustSpecDate() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetQueryCustSpecDate(data).then((res) => {
        if (res.success) {
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.CopyIndex =
              (this.paging.page - 1) * this.paging.size + index + 1;
            item.specDateText = this.renderTime(item.specDate).substring(0, 10);
            item.createTime = this.renderTime(item.createTime);
            item.updateTime = this.renderTime(item.updateTime);
            item.noticeModeText = this.ReturnMethod(item.noticeMode);
          });
          this.list.tbody = this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false;
      });
    },
    TouchTheBottom() {
      this.paging.page++;
      this.RGetQueryCustSpecDate();
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberTable {
  margin-top: 40px;
}
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  margin-left: 25px;
  height: 990px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.bottom-div {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-content: center;
  justify-content: flex-end;
  padding-right: 50px;
}
.member-dialog {
  .establishg-div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
    .border-bottom {
      border-bottom: 1px solid #8e8e8e;
    }
    .input-text {
      width: 350px;
      height: 35px;
      line-height: 35px;
    }
    .laber-name {
      width: 350px;
      height: 35px;
      border: 1px solid #797979;
      background-color: #f2f2f2;
      color: #333333;
      line-height: 35px;
      padding: 0 10px;
      border-radius: 2px;
    }
  }
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
